import type { RecordType } from "./recordTypes";

export type TrackerState = "old" | "new" | "mixed" | "other" | "missing" | "failed";

export type TrackerRow = {
  resolver: string;
  location: string;
  state: TrackerState;
  status: "ok" | "nxdomain" | "timeout" | "error" | "servfail";
  records: string[];
  latencyMs?: number;
  message?: string;
};

export type TrackerReport = {
  host: string;
  type: RecordType;
  oldValue: string;
  newValue: string;
  checkedAt: string;
  rows: TrackerRow[];
  counts: Record<TrackerState, number>;
  summary: {
    title: string;
    detail: string;
    tone: "ok" | "warn" | "bad";
  };
};

export async function checkTracker(input: {
  host: string;
  type: RecordType;
  oldValue: string;
  newValue: string;
}): Promise<TrackerReport> {
  const res = await fetch("/api/trackers/check", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  const body = await res.json() as { ok?: boolean; report?: TrackerReport; message?: string };
  if (!res.ok || !body.ok || !body.report) throw new Error(body.message ?? "Could not check this DNS change.");
  return body.report;
}
